import { setGeneralStep } from "../../helpType/helpTypeSlice";
import { GeneralStepsEnum } from "../../../common/constants/GeneralStepsEnum";
import { unsetAppointment } from "../../appointment/appointmentSlice";
import { updateDossier } from "../../../app/rootReducer";
import { PatchStepsEnum } from "../../../common/constants/PatchStepsEnum";
import { AppDispatch } from "../../../app/store";
import { ContractorEnum } from "../../../common/constants/ContractorEnum";

interface Props {
    dispatch: AppDispatch;
    activeContractorId: number;
    type: ContractorEnum;
}

export const handleContractorClick = (props: Props): void => {
    const { dispatch, activeContractorId, type } = props;

    switch (type) {
        case ContractorEnum.LEASE:
            dispatch(setGeneralStep(GeneralStepsEnum.Lease));
            break;
        case ContractorEnum.INSURANCE:
            dispatch(setGeneralStep(GeneralStepsEnum.Insurance));
            break;
    }

    dispatch(unsetAppointment());

    if (activeContractorId !== undefined && activeContractorId) {
        dispatch(
            updateDossier({
                data: { contractor_id: activeContractorId },
                method: PatchStepsEnum.PatchContractor,
            }),
        ).then(() => {
            dispatch(setGeneralStep(GeneralStepsEnum.Appointment));
        });
    }
};
